export const tourText = {
  textAreaContainer: {
    title: 'AI-powered creation',
    description: 'Type a topic and AI will generate content.',
  },
  interactiveLessons: {
    title: 'Make lessons interactive',
    description: 'Enhance learning with quizzes.',
  },
  draftCourses: {
    title: 'Unpublished lessons',
    description: 'Edit and publish your lessons.',
  },
};
